import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { PROMISE_LOCK_IMG } from 'src/defaultImages.js';
import { CollectionInfrastructureHelperService } from '../../collection-infrastructure-helper.service';

@Component({
  selector: 'app-promise-lock-modal',
  templateUrl: './promise-lock-modal.component.html',
  styleUrls: ['./promise-lock-modal.component.css'],
})
export class PromiseLockModalComponent implements OnInit {
  images: any = {
    PROMISE_LOCK_IMG,
  };
  isSubscription: number = 1;

  constructor(
    private _modalService: NzModalService,
    private _modalRef: NzModalRef,
    private _ciHelperSerive: CollectionInfrastructureHelperService
  ) {}

  ngOnInit() {}

  async talkToExpert() {
    const { TalkExpertFormComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/shared modal/talk-expert-form/talk-expert-form.component'
    );
    this._modalService.create({
      nzClosable: false,
      nzContent: TalkExpertFormComponent,
      nzComponentParams: { subscription: this.isSubscription },
      nzBodyStyle: { padding: '20px' },
      nzStyle: { top: '20px' },
      nzFooter: null,
      nzWidth: 500,
      nzMaskClosable: false,
    });
  }
  renew() {
    this._modalRef.close({ data: null, status: 0 });
    this._ciHelperSerive.redirectToSubscriptionPage();
  }
}
